import React from "react";

function HighlightSearchTerm({ title, searchTerm, invertHighlight }) {
    if (searchTerm === undefined || title == null) {
        return title;
    }

    // Normalisiert Umlaute (ä->a, ö->o, ü->u) und macht lowercase
    const normalize = (s) =>
        String(s)
            .toLowerCase()
            .replace(/ä/g, "a")
            .replace(/ö/g, "o")
            .replace(/ü/g, "u");

    // Suchbegriffe aufbereiten
    const terms = (Array.isArray(searchTerm) ? searchTerm : [searchTerm])
        .map((t) => (typeof t === "string" ? t.trim() : ""))
        .filter(Boolean);

    if (terms.length === 0) {
        return title;
    }

    const text = String(title);
    const normText = normalize(text);

    // Ersten (frühesten) Treffer über alle Begriffe finden,
    // wobei Umlaute wie normale Buchstaben interpretiert werden
    let bestIndex = -1;
    let bestNormLen = 0;

    for (const term of terms) {
        const normTerm = normalize(term);
        if (!normTerm) continue;

        const idx = normText.indexOf(normTerm);
        if (idx !== -1 && (bestIndex === -1 || idx < bestIndex)) {
            bestIndex = idx;
            bestNormLen = normTerm.length;
        }
    }

    if (bestIndex === -1) {
        return title;
    }

    // Slice anhand der ermittelten Index-Position im Originaltext
    const before = text.slice(0, bestIndex);
    const highlight = text.substr(bestIndex, bestNormLen);
    const after = text.slice(bestIndex + bestNormLen);

    return (
        <>
            <span key="before">{before}</span>
            <span className="highlight" key="highlight">
                {highlight}
            </span>
            <span key="after">{after}</span>
        </>
    );
}

export default HighlightSearchTerm;